import { render, staticRenderFns } from "./product-template-duplicate-modal.vue?vue&type=template&id=ff498b50&scoped=true&"
import script from "./product-template-duplicate-modal.vue?vue&type=script&lang=ts&"
export * from "./product-template-duplicate-modal.vue?vue&type=script&lang=ts&"
import style0 from "./product-template-duplicate-modal.vue?vue&type=style&index=0&id=ff498b50&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff498b50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
